exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".app-footer{text-align:center;color:#4b585f}", "", {"version":3,"sources":["/home/davidwolff/projects/scms/secure-customer-messaging-ui/src/components/Footer.vue"],"names":[],"mappings":"AACA,YACE,kBAAmB,AACnB,aAAe,CAChB","file":"Footer.vue","sourcesContent":["\n.app-footer {\n  text-align: center;\n  color: #4b585f;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a87b0c44","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = Yyfp
// module chunks = 1